// extracted by mini-css-extract-plugin
module.exports = {"container":"I-tc6YvaCVfeZRr4_08YC"};